import ofertaNomina, {
  infoCampania,
  nombresTarjetas,
  nombresTarjetasAdobe
} from "@/config/brands/ofertaNomina";

describe("ofertaNomina config", () => {
  it("configuracion exportada por defecto", () => {
    expect(ofertaNomina).toBeDefined();
    expect(ofertaNomina).not.toBeNull();
  });

  it("export de funcion para info campanias", () => {
    const paquete00 = {
      tipoPaquete: "00"
    };
    const paquete01 = {
      tipoPaquete: "01"
    };
    const paquete02 = {
      tipoPaquete: "02"
    };
    const paquete04 = {
      tipoPaquete: "04"
    };
    const paquete07 = {
      tipoPaquete: "07"
    };
    const paquete08 = {
      tipoPaquete: "08"
    };
    const paquete09 = {
      tipoPaquete: "09"
    };

    expect(infoCampania).toBeDefined();
    expect(infoCampania("")).toEqual({});
    expect(infoCampania(paquete00)).toEqual({});
    expect(infoCampania(paquete01)).toEqual({});
    expect(infoCampania(paquete02)).toEqual({});
    expect(infoCampania(paquete04)).toEqual({});
    expect(infoCampania(paquete07)).toEqual({});
    expect(infoCampania(paquete08)).toEqual({});
    expect(infoCampania(paquete09)).toEqual({});
    expect(infoCampania).not.toBeNull();
  });

  it("nombres tarjetas como objeto vacio", () => {
    expect(nombresTarjetas).toBeDefined();
    expect(nombresTarjetas).toEqual({});
  });

  it("Datos de tarjeta adobe son exportados correctamente", () => {
    const tarjetas = {};
    expect(nombresTarjetasAdobe).toEqual(tarjetas);
  });
});
